<script lang="ts">
    import { beforeUpdate, onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { Article, storeArticle, storeMyArticles, storeEmptyArticle } from "../scripts/blog";
    import { storeLanguage, lang_fr } from "../scripts/store";
    import { addNotificationInfo }  from "../scripts/toaster";
    import { redirectTo } from '../scripts/router1';
    import { idPageArticle, idPageMyArticles } from '../scripts/router2';
    import Editor from '@tinymce/tinymce-svelte';
    import { updateArticle, addArticle } from '../scripts/apiArticles';
    import { writable } from 'svelte/store';
    import { storeUserLogin } from '../scripts/user';

    let isCreation: boolean = false;
    const oldArticle = writable(<Article>{});
    let text = $storeArticle.text_fr;
    let title = $storeArticle.title_fr;
    let subtitle = $storeArticle.subtitle_fr;

    
    let tinymceConf = {
        menubar: 'edit',
        toolbar: 'undo redo | styles | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link',
        plugins: ['link', 'autolink', 'lists'],
    }

    beforeUpdate(() => {
        if ($storeArticle.id == 0) {
            isCreation = true;
        } else {
            oldArticle.set($storeArticle);
        }
    })

    onMount(async () => {
        window.scrollTo(0,0);
	});

    function validation() {
        let photoFile = (<HTMLInputElement>document.getElementById("photoFile")).files[0];
        $storeArticle.text_fr = text;
        $storeArticle.title_fr = title;
        $storeArticle.subtitle_fr = subtitle;
        const id_author: string = String($storeUserLogin.id);
        if (isCreation) {
            const isModify = addArticle($storeArticle.id, $storeArticle.title_fr, $storeArticle.subtitle_fr, $storeArticle.text_fr, id_author, photoFile);
            isModify.then((data) => {
                if (data) {
                    storeMyArticles.set([]);
                    setTimeout(() => {
                        redirectTo(idPageArticle, "?id="+$storeArticle.id)
                    }, 500);
                }
            })
        } else {
            const isModify = updateArticle($storeArticle.id, $storeArticle.title_fr, $storeArticle.subtitle_fr, $storeArticle.text_fr, photoFile);
            isModify.then((data) => {
                if (data) {
                    storeMyArticles.set([]);
                    setTimeout(() => {
                        redirectTo(idPageArticle, "?id="+$storeArticle.id)
                    }, 500);
                }
            })
        }
    }

    function annulation() {
        storeArticle.set($oldArticle);
        if (isCreation) {
            redirectTo(idPageMyArticles)
        } else {
            redirectTo(idPageArticle, "?id="+$storeArticle.id)
        }
    }
    
</script>
    
<style lang="scss">

    .articleedition {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            margin: 50px 0 0 0;
        }
        &__header {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__intro {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__photo {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            &__img {
                width: 100%;
            }
            &__select {
                width: 100%;
                margin: 10px 0 0 0;
            }
        }
        &__subtitle {
            margin: 10px 0 10px 0;
        }
        &__date {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
        }
        &__rate {
            width: 100%;
            &__img {
                width: 20px;
                margin: 0 10px 0 10px;
            }
        }
        &__update {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 10px 0 10px 0;
            width: 50%;
            &__button {
                padding: 5px 5px 5px 5px;
                margin: 5px 5px 5px 5px;
            }
        }
        &__tinymce {
            width: 100%;
            margin: 30px 0 30px 0;
        }
        
        &__footer {
            width: 100%;
            margin: 30px 0 30px 0;
        }

    }

    @include large {
        .articleedition {
            &__header {
                width: 100%;
                display: grid;
                grid-template-columns: 50% 50%;
                gap: 30px;
                justify-content: flex-start;
            }
            &__intro {
                align-items: flex-start;
            }
            &__update {
                flex-direction: row;
                justify-content: flex-end;
                width: 100%;
                &__button {
                    min-width: 150px;
                    margin: 0 5px 0 5px;
                }
            }
        }
    }

</style>

<div class="articleedition">
    {#if isCreation}
        {#if ($storeLanguage == $lang_fr)}
        <PageHeader props="Création d'un article"/>
        {:else}
        <PageHeader props="Creation of an article"/>
        {/if}
    {:else}
        {#if ($storeLanguage == $lang_fr)}
        <PageHeader props="Modification d'un article"/>
        {:else}
        <PageHeader props="Modify an article"/>
        {/if}
    {/if}
    <div class="bloc articleedition__bloc">
        <div class="articleedition__header">
            <div class="articleedition__photo">
                {#if ($storeArticle.photo != undefined && $storeArticle.photo != "")}
                <img class="articleedition__photo__img" src="../assets/images/articles/{$storeArticle.id}_{$storeArticle.photo}" alt="article">
                {/if}
                {#if ($storeLanguage == $lang_fr)}
                <label for="image-file" class="btn">Photo de couverture</label>
                {:else}
                <label for="image-file" class="btn">Cover photo</label>
                {/if}
            <input class="articleedition__photo__select" id="photoFile" name="photoFile" type="file"/>
            </div>
            <div class="articleedition__intro">
                <div class="articleedition__title font__h2">
                    {#if ($storeLanguage == $lang_fr)}
                    <label for="title_fr">Titre</label>
                    {:else}
                    <label for="title_fr">Title</label>
                    {/if}
                </div>
                <input type="text" name="title_fr" maxlength="250" bind:value={title} >
                <div class="articleedition__subtitle font__h4">
                    {#if ($storeLanguage == $lang_fr)}
                    Sous titre
                    {:else}
                    Subtitle
                    {/if}
                </div>
                <input type="text" name="subtitle_fr" maxlength="250" bind:value={subtitle} >
            </div>
        </div>
        <div class="articleedition__tinymce">
            <Editor apiKey="rxg1t1dz8woanlru3kkda0qcfar2fwz4qciygpz0uyv1snyh" conf={tinymceConf} bind:value={text}/>
        </div>
        <div class="articleedition__update">
            {#if ($storeLanguage == $lang_fr)}
            <input class="button articleedition__update__button" type="submit" on:click={annulation} value="Annuler">
            <input class="button articleedition__update__button" type="submit" on:click={validation} value="Valider">
            {:else}
            <input class="button articleedition__update__button" type="submit" on:click={annulation} value="Cancel">
            <input class="button articleedition__update__button" type="submit" on:click={validation} value="Validate">
            {/if}
        </div>
    </div>
</div>
